import _, { isNil } from "lodash";
import moment from "moment";
import { useEffect, useState } from "react";
import GlobalSettingAPI from "restAPI/GlobalSettingAPI";
import { FindingCustomField, PROPOSE_TYPE } from "types/tenantConfig";
import { FieldTypes } from "utils/formUtils";
import htmlToMarkDown, { sanitizeMarkdown } from "utils/htmlToMarkDownUtil";

export type ProposeFieldsConfig = Partial<{
  [key in PROPOSE_TYPE]: {
    checked: boolean;
    customFields: string[];
  };
}>;

const useProposeFlowCustomFields = (
  shouldFetch = true,
): [boolean, ProposeFieldsConfig, FindingCustomField[]] => {
  const [loading, setLoading] = useState<boolean>(false);
  const [proposalConfig, setProposalConfig] = useState<ProposeFieldsConfig>({});
  const [availableCustomFields, setAvailableCustomFields] = useState<
    FindingCustomField[]
  >([]);

  useEffect(() => {
    if (!shouldFetch) return;
    setLoading(true);
    const { cancel, promise } = GlobalSettingAPI.getProposeCustomFields();
    const { cancel: cancel2, promise: promise2 } =
      GlobalSettingAPI.getFindingCustomFields();

    Promise.all([promise, promise2])
      .then(([res, res2]) => {
        const config: ProposeFieldsConfig = {};
        _.forEach(res, (value) => {
          config[value.key as PROPOSE_TYPE] = {
            checked: value.enabled,
            customFields: value.customFields,
          };
        });
        setProposalConfig(config);
        setAvailableCustomFields(res2?.findingCustomFields);
      })
      .finally(() => setLoading(false));
    return () => {
      cancel();
      cancel2();
    };
  }, [shouldFetch]);

  return [loading, proposalConfig, availableCustomFields];
};

export default useProposeFlowCustomFields;

export const getFormFieldTypeFromCustomFieldType = (fieldType: string) => {
  let type;
  switch (fieldType) {
    case "date":
      type = FieldTypes.DATE;
      break;
    case "long":
      type = FieldTypes.NUMBER;
      break;
    case "float":
      type = FieldTypes.NUMBER;
      break;
    case "boolean":
      type = FieldTypes.BOOLEAN;
      break;
  }
  return type;
};

export const getFieldValueFromFormValue = (
  value: string,
  field: FindingCustomField,
) => {
  let fieldValue: any = value;
  if (field.type === "text") {
    fieldValue = sanitizeMarkdown(htmlToMarkDown(value));
  } else if (field.type === "date") {
    fieldValue = moment(value).format(
      field.format === "YYYY-MM-DD'T'hh:mm:ssX"
        ? "YYYY-MM-DD[T]hh:mm:ss[Z]"
        : field.format,
    );
  } else if (field.type === "float" || field.type === "long") {
    fieldValue = String(value);
  } else if (field.type === "boolean") {
    fieldValue = isNil(value) ? "false" : String(value);
  }
  return fieldValue;
};
